/**
 * Palette de couleurs d'avatar.
 * Ces couleurs sont utilisees pour differencier visuellement les participants
 * dans les conversations du canal collaboratif.
 */
export const AVATAR_COLORS = [
  '#9579B8', // purple
  '#6DA544', // green
  '#FFC107', // yellow
  '#7998B8', // blue-gray
  '#D53F8C', // pink
  '#00B5D8', // cyan
  '#DD6B20', // orange
  '#319795', // teal
];

/**
 * Retourne une couleur d'avatar basee sur un index.
 * L'index est modulo la taille du tableau pour cycler les couleurs.
 */
export const getAvatarColorByIndex = (index: number) => {
  return AVATAR_COLORS[index % AVATAR_COLORS.length];
};

/**
 * Retourne une couleur d'avatar consistante basee sur un nom.
 * Le meme nom retournera toujours la meme couleur.
 */
export const getAvatarColorByName = (name: string) => {
  let sum = 0;
  for (const char of name) {
    sum += char.charCodeAt(0);
  }
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
};
